import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminWaitlists = lazy(() => import("@/pages/admin/AdminWaitlists"));

export const Route = createFileRoute("/admin/waitlists")({
  component: AdminWaitlists,
});
